import { Pipe, PipeTransform } from '@angular/core';
import { IncomeSourceTypeCode } from '../security-deposit/applications/models/applications.model';

@Pipe({
  standalone: false, name: 'incomeSourceType' })
export class IncomeSourceTypePipe implements PipeTransform {
  private types: { [key: string]: string } = {};

  constructor() {
    this.types[IncomeSourceTypeCode.employed] = 'Employed';
    this.types[IncomeSourceTypeCode.student] = 'Student / Intern';
    this.types[IncomeSourceTypeCode.caregiver] = 'Stay at home / Caregiver';
    this.types[IncomeSourceTypeCode.selfEmployed] = 'Self-employed / Freelancer';
    this.types[IncomeSourceTypeCode.unemployed] = 'Unemployed';
    this.types[IncomeSourceTypeCode.other] = 'Other';
    this.types[IncomeSourceTypeCode.rentVoucher] = 'Rent Voucher';
  }

  transform(value: IncomeSourceTypeCode): string {
    return this.types[value] ?? 'Unknown';
  }
}
